import { useEffect, type FC } from 'react';

import { useAnalytics } from '../context';
import type { TProductPermalink, MinimalVariantForTracking } from '../types';

export interface TrackViewItemProps {
  variant: MinimalVariantForTracking;
  itemUrl: TProductPermalink;
}

export const TrackViewItem: FC<TrackViewItemProps> = ({ variant, itemUrl }) => {
  const tracker = useAnalytics();

  useEffect(() => {
    tracker.trackViewItem({ variant, itemUrl });
  }, []);

  return null;
};
